import { useEffect, useRef } from 'react';

// Reload an office page's data every `ms` while it's on screen, and as soon
// as the tab comes back to the front, so other people's changes (a booking
// moved, a day optimised) show up without pressing Refresh. Pages keep what
// they have while reloading, so nothing flashes.
export function useAutoRefresh(load, ms = 30_000) {
  const fn = useRef(load);
  fn.current = load;
  useEffect(() => {
    const run = () => { if (document.visibilityState === 'visible') fn.current(); };
    const every = setInterval(run, ms);
    document.addEventListener('visibilitychange', run);
    window.addEventListener('focus', run);
    return () => { clearInterval(every); document.removeEventListener('visibilitychange', run); window.removeEventListener('focus', run); };
  }, [ms]);
}
